import styled from 'styled-components';
import media from 'styled-media-query';

const Markdown = styled.article`
  text-align: justify;
  letter-spacing: 0.05rem;
  font-size: 1.05rem;
  line-height: 2rem;
  p {
    text-indent: 1em;
    .math {
      display: block;
      text-align: center;
    }
  }
  h1 {
    color: var(--font-color);
    padding: 2rem 0;
    margin: 1rem 0;
  }
  h2 {
    color: var(--font-color);
    padding: 2rem 0;
    margin: 1rem 0;
  }
  h3 {
    color: var(--font-color);
    padding: 1rem 0;
  }
  blockquote {
    margin: 1.5em;
    padding: 0.5em;
    border-left: 0.3em solid #d1d1d1;
    background: #f4f4f4;
  }
  table {
    border-collapse: collapse;
    border: 2px solid #b9b9b9;
    width: 100%;
    table-layout: fixed;
    word-break: break-all;
    word-wrap: anywhere;
    th {
      padding: 0.35em;
      font-size: 1.25em;
      border: 2px solid #b9b9b9;
      border-bottom: double 6px #b9b9b9;
    }
    td {
      padding: 0.35em;
      font-size: 1em;
      border: dashed 2px #b9b9b9;
    }
  }
  a {
    color: #3872b8;
  }
  a[href^='http'] {
    word-break: break-all;
  }
  hr {
    margin: 3rem 0;
    border: none;
    border-top: 1px dashed #bbb;
    position: relative;
    &:after {
      content: '\\002702';
      display: inline-block;
      position: absolute;
      left: 50%;
      top: -0.75rem;
      color: #bbb;
      font-size: 1.5rem;
      line-height: 1.5rem;
    }
  }
  ${media.lessThan('medium')`
  ul{
    padding-left: 1rem;
  }
  `}
`;
export default Markdown;
